import { initializeApp } from 'firebase/app';
import { getAuth, FacebookAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

// Firebase configuration (replace with your Firebase project config)

const firebaseConfig = {
    apiKey: "AIzaSyDm09Sn5iO2IePR9xs1BUyGmN-wF7_QjnI",
    authDomain: "fotonest.firebaseapp.com",
    projectId: "fotonest",
    storageBucket: "fotonest.firebasestorage.app",
    messagingSenderId: "698847613167",
    appId: "1:698847613167:web:9b235af2c79d55070bcb1a",
    measurementId: "G-6K5CKZ728S"
};

const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth and Firestore
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

const provider = new FacebookAuthProvider();

export { auth, provider, db , storage, ref, uploadBytes, getDownloadURL };
